/* ============================================================
   Restock Rocket "Notify me" popup -- Easy Clothes branding
   (design B from the 2026-10-02 prototypes).

   Restock Rocket renders its popup itself (#formContainer, created
   fresh every time it opens), so this file never replaces the app's
   own form controls -- it hides a few of them and adds branded
   controls that drive the originals:
   - size pills       -> set the hidden #form-Select and fire "change"
   - Email/SMS toggle -> show one of the app's own inputs, clear the other
   - product photo, "Sold out" chip, Cormorant heading, logo
   - "You're on the list" heading on the success screen
   - marketing opt-in tick box -> Klaviyo list (only after STOQ confirms)
   Everything is idempotent: enhance() runs on every DOM change and only
   adds what's missing, so app re-renders are safe.
   Product data comes from #ec-nm-data (snippets/restock-modal-brand.liquid),
   or from window.ecNmOverride when the Complete the Look drawer opens the
   popup for a paired product (see data() below).
   ============================================================ */
(function () {
    var DATA = null;
    function pageData() {
        if (DATA) return DATA;
        var el = document.getElementById('ec-nm-data');
        try { DATA = JSON.parse(el ? el.textContent : '{}'); } catch (e) { DATA = {}; }
        DATA.prices = DATA.prices || {};
        return DATA;
    }

    /* The Complete the Look drawer (component-ctl-quick-add.js, 2026-10-14)
       can open this popup for one of the paired products instead of the page's
       product. Just before opening it sets window.ecNmOverride = { title,
       image, price, prices } and it clears it when the popup closes. While it
       is set (and matches the sizes in the popup) the popup shows that
       product's photo, name and price. Klaviyo settings always come from the
       page. */
    function data() {
        var o = window.ecNmOverride;
        if (o) {
            var sel = document.querySelector('#formContainer #form-Select');
            var first = sel && sel.options.length ? sel.options[0].value : null;
            if (!first || (o.prices && o.prices[first])) {
                return { title: o.title, image: o.image, price: o.price, prices: o.prices || {}, klaviyo: pageData().klaviyo };
            }
        }
        return pageData();
    }

    function make(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
    }

    function logoNode() {
        var src = document.querySelector('header a[href="/"] svg, .header__logo svg');
        if (!src) return null;
        var svg = src.cloneNode(true);
        svg.removeAttribute('class');
        svg.removeAttribute('width');
        svg.removeAttribute('height');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        var t = svg.querySelector('title');
        if (t) t.parentNode.removeChild(t);
        var wrap = make('span', 'ec-nm-logo');
        wrap.appendChild(svg);
        return wrap;
    }

    function priceFor(select) {
        var d = data();
        return (select && d.prices[select.value]) || d.price || '';
    }

    function setPrice(fc, text) {
        var els = fc.querySelectorAll('.ec-nm-price');
        for (var i = 0; i < els.length; i++) els[i].textContent = text;
    }

    function buildAside(fc, reg, select) {
        if (reg.querySelector(':scope > .ec-nm-aside')) return;
        var d = data();
        var aside = make('div', 'ec-nm-aside');
        if (d.image) {
            var img = make('img', 'ec-nm-aside-img');
            img.src = d.image;
            img.alt = d.title || '';
            aside.appendChild(img);
        }
        var meta = make('div', 'ec-nm-aside-meta');
        meta.appendChild(make('span', 'ec-nm-aside-name', d.title || ''));
        meta.appendChild(make('span', 'ec-nm-price', priceFor(select)));
        aside.appendChild(meta);
        reg.insertBefore(aside, reg.firstChild);
    }

    function buildHeader(fc) {
        var head = fc.querySelector('#form-Header-Container');
        if (!head || head.querySelector('.ec-nm-logo')) return;
        var logo = logoNode();
        if (logo) head.insertBefore(logo, head.firstChild);
    }

    function buildIntro(fc, content, select) {
        if (content.querySelector('.ec-nm-intro')) return;
        var d = data();
        var intro = make('div', 'ec-nm-intro');
        if (d.image) {
            var img = make('img', 'ec-nm-thumb');
            img.src = d.image;
            img.alt = d.title || '';
            intro.appendChild(img);
        }
        var text = make('div', 'ec-nm-intro-text');
        text.appendChild(make('span', 'ec-nm-chip', 'Sold out'));
        var h = make('p', 'ec-nm-title', 'Be the first to know');
        h.setAttribute('aria-hidden', 'true');
        text.appendChild(h);
        var meta = make('span', 'ec-nm-meta');
        meta.appendChild(document.createTextNode((d.title || '') + ' · '));
        meta.appendChild(make('span', 'ec-nm-price', priceFor(select)));
        text.appendChild(meta);
        text.appendChild(make('p', 'ec-nm-desc', 'Pick your size and we’ll tell you the moment it’s back.'));
        intro.appendChild(text);

        var head = content.querySelector('#form-Header-Container');
        if (head && head.nextSibling) content.insertBefore(intro, head.nextSibling);
        else content.insertBefore(intro, content.firstChild);
    }

    function syncPills(fc, select) {
        var pills = fc.querySelectorAll('.ec-nm-pill');
        for (var i = 0; i < pills.length; i++) {
            pills[i].setAttribute('aria-pressed', String(pills[i].dataset.value === select.value));
        }
        setPrice(fc, priceFor(select));
    }

    function buildSizes(fc, select) {
        if (!select || fc.querySelector('.ec-nm-sizes')) return;
        var opts = Array.prototype.slice.call(select.options);
        var field = make('div', 'ec-nm-field ec-nm-sizes');
        if (opts.length < 2 && (!opts[0] || /default title/i.test(opts[0].text))) {
            field.hidden = true; /* one-size product: nothing to pick */
        }
        field.appendChild(make('span', 'ec-nm-label', 'Your size'));
        var row = make('div', 'ec-nm-pills');
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', 'Your size');
        opts.forEach(function (o) {
            var b = make('button', 'ec-nm-pill', o.text);
            b.type = 'button';
            b.dataset.value = o.value;
            if (o.disabled) b.disabled = true;
            b.addEventListener('click', function () {
                if (select.value === o.value) return;
                select.value = o.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                syncPills(fc, select);
            });
            row.appendChild(b);
        });
        field.appendChild(row);
        select.parentNode.insertBefore(field, select.nextSibling);
        select.addEventListener('change', function () { syncPills(fc, select); });
        syncPills(fc, select);
    }

    function clearInput(input) {
        if (!input || !input.value) return;
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function setChannel(fc, channel) {
        fc.setAttribute('data-ec-channel', channel);
        var tabs = fc.querySelectorAll('.ec-nm-tab');
        for (var i = 0; i < tabs.length; i++) {
            tabs[i].setAttribute('aria-pressed', String(tabs[i].dataset.channel === channel));
        }
        /* Only one channel is submitted: empty the hidden one so the app
           doesn't validate or send a half-typed value. */
        if (channel === 'email') clearInput(fc.querySelector('#form-Phone'));
        else clearInput(fc.querySelector('#form-Email'));
    }

    function buildChannel(fc) {
        var emailBox = fc.querySelector('#form-Email-Container');
        var phoneBox = fc.querySelector('#form-Phone-Container');
        if (!emailBox || !phoneBox || fc.querySelector('.ec-nm-channel')) return;
        var group = emailBox.parentNode;
        var field = make('div', 'ec-nm-field ec-nm-channel');
        field.appendChild(make('span', 'ec-nm-label', 'Notify me by'));
        var toggle = make('div', 'ec-nm-toggle');
        toggle.setAttribute('role', 'group');
        toggle.setAttribute('aria-label', 'Notify me by');
        [['email', 'Email'], ['sms', 'SMS']].forEach(function (c) {
            var b = make('button', 'ec-nm-tab', c[1]);
            b.type = 'button';
            b.dataset.channel = c[0];
            b.addEventListener('click', function () {
                setChannel(fc, c[0]);
                var target = fc.querySelector(c[0] === 'email' ? '#form-Email' : '#form-Phone');
                if (target) target.focus();
            });
            toggle.appendChild(b);
        });
        field.appendChild(toggle);
        group.parentNode.insertBefore(field, group);
        group.classList.add('ec-nm-inputs');
        setChannel(fc, fc.getAttribute('data-ec-channel') || 'email');
    }

    function buildSuccess(fc) {
        var txt = fc.querySelector('#form-Success-Text');
        if (!txt || fc.querySelector('.ec-nm-success-title')) return;
        fc.classList.add('ec-nm-done');
        if (pending && pending.optin) subscribeToKlaviyo(pending.email);
        pending = null;
        var h = make('p', 'ec-nm-title ec-nm-success-title', 'You’re on the list');
        txt.parentNode.insertBefore(h, txt);
    }

    /* ---------- Marketing opt-in -> Klaviyo ----------
       Only one tick box: STOQ's own "Notify me about other news, sales..."
       box (#form-Consent-Input, from STOQ's marketing-consent setting; our
       separate box was removed 2026-10-14 so shoppers don't see two). The
       restock signup always goes to STOQ. If STOQ's box is ticked on the
       email channel and STOQ confirms the signup, the email is also added to
       the Klaviyo list set in #ec-nm-data (Klaviyo's public client API). */
    var pending = null; /* { email, optin } captured when the button is pressed */

    function buildOptin(fc) {
        var btn = fc.querySelector('#form-Button');
        var d = data();
        if (!btn || !d.klaviyo || !d.klaviyo.company || !d.klaviyo.list) return;
        var old = fc.querySelector('.ec-nm-optin');
        if (old) old.parentNode.removeChild(old);
        if (btn.dataset.ecNmOptin) return;
        btn.dataset.ecNmOptin = '1';
        btn.addEventListener('click', function () {
            var email = fc.querySelector('#form-Email');
            var ticked = fc.querySelector('#form-Consent-Input');
            pending = {
                email: email ? String(email.value || '').trim() : '',
                optin: !!(ticked && ticked.checked && fc.getAttribute('data-ec-channel') !== 'sms')
            };
        }, true);
    }

    function subscribeToKlaviyo(email) {
        var k = data().klaviyo;
        if (!k || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
        var body = {
            data: {
                type: 'subscription',
                attributes: {
                    custom_source: 'Back in stock popup',
                    profile: { data: { type: 'profile', attributes: { email: email } } }
                },
                relationships: { list: { data: { type: 'list', id: k.list } } }
            }
        };
        try {
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k.company), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
                body: JSON.stringify(body),
                keepalive: true
            }).then(function (r) {
                window.ecNmLastKlaviyoStatus = r.status;
            }).catch(function () {});
        } catch (e) {}
    }

    /* STOQ answers "You've already subscribed for alerts to this product"
       when the email is already on this restock alert. The alert is still in
       place, so a ticked opt-in should still reach Klaviyo. */
    function handleAlreadySubscribed(fc) {
        if (!pending || !pending.optin) return;
        var err = fc.querySelector('#form-Error-Message');
        if (!err || !/already subscribed/i.test(err.textContent || '')) return;
        var email = pending.email;
        pending = null;
        subscribeToKlaviyo(email);
    }

    function placeholders(fc) {
        var phone = fc.querySelector('#form-Phone');
        if (phone && phone.getAttribute('placeholder') !== 'Phone number') phone.setAttribute('placeholder', 'Phone number');
    }

    function enhance() {
        var fc = document.getElementById('formContainer');
        if (!fc) return;
        placeholders(fc);
        if (!fc.classList.contains('ec-nm')) fc.classList.add('ec-nm');
        var reg = fc.querySelector('#form-Registration-Container');
        var content = fc.querySelector('.form-Content-Container');
        var select = fc.querySelector('#form-Select');
        if (reg) buildAside(fc, reg, select);
        buildHeader(fc);
        if (content) buildIntro(fc, content, select); /* one-size products have no #form-Select */
        if (select) buildSizes(fc, select);
        buildChannel(fc);
        buildOptin(fc);
        handleAlreadySubscribed(fc);
        buildSuccess(fc);
    }

    /* Run straight from the observer callback (a microtask), so the
       popup is restyled before it is first painted -- no flash of the
       app's default look. Our own DOM additions re-trigger the observer
       once; enhance() then finds nothing missing and stops. */
    var running = false;
    function schedule() {
        if (running) return;
        running = true;
        try { enhance(); } catch (e) {}
        running = false;
    }

    function start() {
        new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
        schedule();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
})();
